/**
 * Component to handle profile bulk upload
 */
import * as React from 'react';
import { Table } from 'antd';
import '../../../css/ProfileBulkUpload.scss';
import { CustomSorter } from '../../Sorter';

const DUPMSG = 'Please select any one row to remove ambiguity.';

interface IDuplicateProfileFilterProps {
    dupProfiles: Array<any>;
    loading: boolean;
    notifySelectedRow: any;
    rowIndex: any;
    isRowVerified: any;
}

interface IDuplicateProfileFilterState {
    columns: Array<any>;
    columnData: Array<any>;
    selectedRowKeys: Array<string>;
}

export default class DuplicateProfileFilter extends React.Component<IDuplicateProfileFilterProps
    , IDuplicateProfileFilterState> {

    constructor(props: IDuplicateProfileFilterProps) {
        super(props);
        this.state = { 
            columns: this.buildColumns(),
            columnData: this.props.dupProfiles,
            selectedRowKeys: []
        };
    }
    
    componentDidMount() {
        if (this.props.isRowVerified) {
            this.setState({ selectedRowKeys: [ this.props.rowIndex]}); 
        }
    }

    onSelectRowChange = (selectedRowKeys: Array<string>) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
        this.props.notifySelectedRow({parentKey: this.props.rowIndex, selectedKey: selectedRowKeys[0]});
    }

    render() {
        const rowSelection = {
            selectedRowKeys : this.state.selectedRowKeys,
            onChange: this.onSelectRowChange,
            type: 'radio' as 'radio'            
        };

        return(
            <div className="ProfileBulkUpload">
                {DUPMSG}
                <Table   
                    columns={this.state.columns} 
                    dataSource={this.state.columnData} 
                    rowKey={record => record.index}
                    bordered={true}
                    rowSelection={rowSelection}                    
                />                         
            </div>
        );
    }

    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns() {
        let columns = [
          { 
            title: 'Row #',
            dataIndex: 'index',
            sorter: (a: any, b: any) => 
                parseInt(a.index, 10) < parseInt(b.index, 10) ? -1 : 1
            ,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'First Name',
            dataIndex: 'firstname',
            sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Middle Name',
            dataIndex: 'middlename',
            sorter: (a: any, b: any) => a.middlename.localeCompare(b.middlename),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Last Name',
            dataIndex: 'lastname',
            sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'ID',
            dataIndex: 'id',
            sorter: (a: any, b: any) => a.id.localeCompare(b.id),
            
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } ,
          {
            title: 'Date of Birth',
            dataIndex: 'dob',
            sorter: (a: any, b: any) => a.dob.localeCompare(b.dob),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } ,
          {
            title: 'Gender',
            dataIndex: 'gender',
            sorter: (a: any, b: any) => {
                let agender = a.gender !== null ? a.gender : '';
                let bgender = b.gender !== null ? b.gender : '';
                return agender <= bgender ? -1 : 1;
                },
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          }          
        ];
        return columns;
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/uploadprofilesteps/DuplicateProfileFilter.tsx